import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { CompanyService } from '../dashboard';
import { Role } from '../dashboard/profile/models/role';

@Injectable()
export class OnboardingGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly companyService: CompanyService) {}

  canActivate(): boolean {
    return this.authService.handleCanActivateFor(Array.of(Role.SME), true);
  }
}
